import React from 'react';
import { motion } from 'framer-motion';
import { ClosingLine, InteriorSlide, SlideTitle } from './SlideShell';
import type { SlideProps } from './SlideShell';
import { learningAreas } from '../../data/snakkerStory';
export function SlideLearning({}: SlideProps) {
  return <InteriorSlide data-id="element-452" data-mp="3ne17l9hymj04">
      <SlideTitle eyebrow="From campaign data to learning" data-id="element-453" data-mp="3ndhqtw41q0no">
        The more we activate, <span className="text-[var(--brand)]" data-id="element-454" data-mp="2zogevyw087dn">the more we learn.</span>
      </SlideTitle>

      <div className="mt-[clamp(1.5rem,3vw,2.75rem)] grid min-h-0 flex-1 grid-cols-2 border-l border-t border-[var(--fg)]/10 md:grid-cols-4" data-id="element-455" data-mp="2zm2m5wosr799">
        {learningAreas.map((area, i) => <motion.section key={area.title} initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.15 + i * 0.1,
        duration: 0.45
      }} className="flex min-h-0 flex-col justify-between border-b border-r border-[var(--fg)]/10 p-[clamp(1rem,2vw,1.85rem)]" data-id="element-456" data-mp="38iv1kmiv6k6s" data-mpi={i}>
            <span className="font-mono text-[clamp(0.6rem,0.78vw,0.72rem)] tracking-[0.2em] text-[var(--muted)]" data-id="element-457" data-mp="2ejcmm2ecav7c">0{i + 1}</span>
            <div data-id="element-458" data-mp="2jhw6lx9dhwx2">
              <h3 className="text-[clamp(1.5rem,2.8vw,2.7rem)] font-extrabold leading-none tracking-[-0.05em] text-[var(--fg)]" data-id="element-459" data-mp="2jhe7msvbt4lg">{area.title}</h3>
              <p className="mt-[clamp(0.6rem,1.1vw,0.9rem)] text-[clamp(0.9rem,1.3vw,1.2rem)] font-medium leading-snug text-[var(--muted)]" data-id="element-460" data-mp="2t9jx9vy3v9xh">{area.question}</p>
            </div>
          </motion.section>)}
      </div>

      <ClosingLine delay={0.65} large data-id="element-461" data-mp="20l4uq8w5uk31">
        Reuse what works. Adapt what doesn’t. <span className="text-[var(--brand)]" data-id="element-462" data-mp="25jg129n8ycgi">Build only what is missing.</span>
      </ClosingLine>
    </InteriorSlide>;
}